import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Official NovaImmo logo (transparent PNG, self-contained gradient mark)
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src="/logo.png" alt="" className={`${className} object-contain`} aria-hidden="true" draggable="false" />
);

export const Logo = ({ light = false }) => {
  const { t } = useTranslation();
  return (
  <Link to="/" className="group flex items-center gap-2.5" data-testid="header-logo" aria-label={t("nav.homeAria")}>
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:scale-110" />
    <span className={`font-display text-[21px] font-bold leading-none tracking-tight ${light ? "text-white" : "text-[#111827]"}`}>
      Nova<span className="font-medium opacity-80">Immo</span>
    </span>
  </Link>
  );
};
